export interface Bike {
  type: string;
  space: number;
}

export enum BikeTypes {
  'bike' = 0,
  'ebike' = 1,
  'hiker' = 2
}

export enum BikeTypesTranslations {
  'bike' = 'Bike',
  'ebike' = 'E-Bike',
  'hiker' = 'Wanderer'
}

export enum BusActionTypes {
  REQUEST = '[bike]REQUEST',
  HIDE_BUS = '[bike]HIDE_BUS',
  UNHIDE_BUS = '[bike]UNHIDE_BUS',
  ERROR = '[bike]ERROR'
}



// WEBPACK FOOTER //
// ./src/store/bus/types.ts